import { useEffect, useContext } from "react";
import Header from "./Header";
import useState from "react-usestateref";
import authservices from "../services/authservices";
import { Link } from "react-router-dom";
import SubFooter from "./SubFooter";
import { useTranslation } from "react-i18next";
import { UserContext } from "../contexts/UserContext";
import i18n from "../translate/i18n";
const AffiliateTerms = () => {
  const [userAuth, setAuth, userAuthref] = useState(false);

  useEffect(() => {
    getSitedata();
  }, []);
  const [siteDatacomes, setSiteData] = useState("");
  const { t } = useTranslation();

  const getSitedata = async () => {
    try {
      const data = await authservices.getsitedata();
      if (data.status == true) {
        setSiteData(data.data);
        // console.log(data, "=-=-=get site datas =-=-", data.data);
      }
    } catch (error) { }
  };

  const [i18nextLngs, seti18nextLngs] = useState(
    localStorage.getItem("i18nextLng") || "en" || "et" || "fi"
  );
  const { i18nextLng } = useContext(UserContext);
  useEffect(() => {
    if (i18nextLng === "en") {
      i18n.changeLanguage(i18nextLngs);
      document.documentElement.lang = i18nextLngs;
      localStorage.setItem("i18nextLng", i18nextLngs);
    }
  }, [i18nextLng]);
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);
  return (
    <>
      <main className="wyscale_landing_main">
        <Header />
      </main>

      <section className="dashboard_content_section">
        <div className="container">
          <div className="smart_dashboard_content" id="terms-condition">
            <h2>{t("BinargeAffiliateTerms")}</h2>
                    <p>{t("BinargeAffiliateTermsDate")}</p>
                    <p>{t("BinargeAffiliateTermscontent")}</p>
            <div className="row">
              <div className="col-lg-12">
                <div className="dash_board_profile_content">
                  <div className="contentpage">
                    <h3>1. {t("Introduction")}</h3>
                    <p>{t("TheseAffiliateTerms")}</p>

                    <h3>2. {t("Eligibility")}</h3>
                    <p>{t("EligibilityFollows")}</p>

                    <ul>
                      <li>{t("YouMustBeAtLeast18YearsOld")}</li>
                      <li>{t("activeBinarge")}</li>
                      <li>{t("YouMayNotParticipate")}</li>
                    </ul>

                    <h3>3. {t("ProgramOverview")}</h3>

                    <ul>
                      <li>{t("YouWillReceiveA")}</li>
                      <li>{t("WhenUserSignsUp")}</li>
                      <li>{t("CommissionsAreTracked")}</li>
                    </ul>
                    <p>{t("POConclusion")}</p>
                    <h3>4. {t("CommissionStructure")}</h3>
                    <h3>{t("One-TimeRewards(fsp)")}</h3>


                    <ul>
                      <li>{t("PremiumSubscriptionPayment")}</li>
                      <li>{t("Promium&Elite")}</li>
                      <li>{t("Elitetrader")}</li>
                    </ul>
                    <p>{t("fsp_conc")}</p>

                    <h3>{t("recurringCommission")}</h3>

                    <ul>
                      <li>{t("CommissionsAreCredited")}</li>
                    </ul>

                    <h3>{t("CommissionBalance")}</h3>

                    <p>{t("CBFollows")}</p>
                    <ul>
                      {t("servicecredit") && <li>{t("servicecredit")}</li>}
                      {t("payforBinarge") && <li>{t("payforBinarge")}</li>}
                      {t("redeemed") && <li>{t("redeemed")}</li>}
                      {t("tradingfunds") && <li>{t("tradingfunds")}</li>}
                    </ul>
                    <p>{t("withdrawalsoftrading")}</p>

                    <h3>5. {t("PayoutAndConditions")}</h3>
                    <p>{t("PayoutAndConditionsfollows")}</p>
                    <ul>
                      {t("fraudulent") && <li>{t("fraudulent")}</li>}
                      {t("self-referrals") && <li>{t("self-referrals")}</li>}
                      {t("accountsareduplicated") && <li>{t("accountsareduplicated")}</li>}
                      {t("marketingmethods") && <li>{t("marketingmethods")}</li>}
                      {t("affiliateviolates") && <li>{t("affiliateviolates")}</li>}
                    </ul>
                    <p>{t("PayoutAndConditionsconclusion")}</p>


                    <h3>6. {t("AcceptablePromotionMethods")}</h3>
                    <p>{t("AcceptablePromotionMethodsFollows")}</p>
                    <ul>
                      {t("blogs") && <li>{t("blogs")}</li>}
                      {t("socialmedia") && <li>{t("socialmedia")}</li>}
                      {t("videocontent") && <li>{t("videocontent")}</li>}
                      {t("onlinecommunities") && <li>{t("onlinecommunities")}</li>}
                      {t("privatenetworks") && <li>{t("privatenetworks")}</li>}
                    </ul>
                    <p>{t("Affiliatesmust")}</p>
                    <ul>
                      <li>{t("representBinarge")}</li>
                      <li>{t("avoidoverstated")}</li>
                      <li>{t("discloseaffiliate")}</li>
                    </ul>

                    <h3>7. {t("ProhibitedActivities")}</h3>
                    <ul>
                      {t("PA_List1") && <li>{t("PA_List1")}</li>}
                      {t("PA_List2") && <li>{t("PA_List2")}</li>}
                      {t("PA_List3") && <li>{t("PA_List3")}</li>}
                      {t("PA_List4") && <li>{t("PA_List4")}</li>}
                      {t("PA_List5") && <li>{t("PA_List5")}</li>}
                      {t("PA_List6") && <li>{t("PA_List6")}</li>}
                    </ul>
                    <p>{t("Pa_conclus")}</p>

                    <h3>8. {t("Compliance&LegalResponsibilities")}</h3>
                    <p>{t("AffiliatesAreResponsible")}</p>
                    <ul>
                      {t("local_advertising_regulations") && <li>{t("local_advertising_regulations")}</li>}
                      {t("tax_reporting_obligations") && <li>{t("tax_reporting_obligations")}</li>}
                      {t("disclosure_requirements") && <li>{t("disclosure_requirements")}</li>}
                      {t("anti-fraud_rules") && <li>{t("anti-fraud_rules")}</li>}
                      {t("platform_policies") && <li>{t("platform_policies")}</li>}
                    </ul>
                    <p>{t("automated_crypto")}</p>

                    <h3>9. {t("Non-CustodialClarification")}</h3>
                    <p>{t("SaaS_automation_platform")}</p>
                    <p>{t("Affiliate_Commissions")}</p>
                    <ul>
                      {t("service_Reward") && <li>{t("service_Reward")}</li>}
                      {t("involve_user") && <li>{t("involve_user")}</li>}
                      {t("brokerage") && <li>{t("brokerage")}</li>}
                    </ul>
                    <h3>10. {t("Term_ination")}</h3>
                    <p>{t("WeReserveRight")}</p>
                    <p>{t("WeReserveRight2")}</p>

                    <h3>11. {t("Modifications")}</h3>
                    <p>{t("MOdification_Right")}</p>
                    <h3>12. {t("Contact10")}</h3>
                    <p>{t("please_contact")}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <SubFooter />
    </>
  );
};

export default AffiliateTerms;
